var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_505_5799)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 12,
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 11.5,
    stroke: "#E8E8E8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3535 20.1465C18.4001 20.1928 18.4371 20.248 18.4624 20.3087C18.4877 20.3694 18.5007 20.4345 18.5008 20.5002C18.5009 20.566 18.488 20.6311 18.4629 20.6919C18.4377 20.7526 18.4009 20.8079 18.3544 20.8544C18.3079 20.9008 18.2527 20.9377 18.1919 20.9628C18.1311 20.988 18.066 21.0009 18.0002 21.0008C17.9345 21.0007 17.8694 20.9876 17.8087 20.9624C17.748 20.9371 17.6929 20.9001 17.6465 20.8535L13.1465 16.3535C13.1 16.3071 13.0632 16.252 13.0381 16.1913C13.0129 16.1306 13 16.0656 13 16C13 15.9343 13.0129 15.8693 13.0381 15.8086C13.0632 15.748 13.1 15.6929 13.1465 15.6465L17.6465 11.1465C17.7403 11.0531 17.8674 11.0007 17.9997 11.0009C18.1321 11.001 18.259 11.0537 18.3526 11.1473C18.4463 11.2409 18.4989 11.3678 18.4991 11.5002C18.4992 11.6326 18.4469 11.7596 18.3535 11.8535L14.207 16L18.3535 20.1465Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_505_5799",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_505_5799"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_505_5799",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuArrow);
export default __webpack_public_path__ + "static/media/menu-arrow.f2254b24bd14e6325e25a80ee5b8ecc6.svg";
export { ForwardRef as ReactComponent };